import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ORDER_TEMPLATE_CAPACITIES = `${TASK_SERVICE}/capacities`;

export const orderTemplateCapacities = {
  getAll: async ({ signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: API_ORDER_TEMPLATE_CAPACITIES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ data, signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: API_ORDER_TEMPLATE_CAPACITIES,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
      signal,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getDetails: async ({ query, signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATE_CAPACITIES}/details`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      query,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getSummary: async ({ query, signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATE_CAPACITIES}/daily-summary`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      query,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
